import React from 'react';
import MapPin from './map-pin';
import directionUrl from '../store/direction-url';
import { ReturnForm } from './return-form';
import StoreTag from './StoreTag';

export function StoreMinified({store, index, origin, onStoreSelected, imagesAreAllowed, retailers, postcode, isMobileDevice, isInPostStoreLocatorRebrandEnabled}) {
  let direction_url = null;
  if (origin && store) {
    direction_url = directionUrl(origin, store);
  }

  const htmlMapPin = () => {
    const mapPin = new MapPin(store, isInPostStoreLocatorRebrandEnabled);

    return (
      <div 
        className="phase-2-numeric-map-pin-list-item"
      >
        <img
          src={mapPin.icon()}
          alt="pin-icon"
          className="pin"
        />
        {(!isInPostStoreLocatorRebrandEnabled || store.store_type !== 'PaypointStore') &&
          <div
            className={`pin-number ${mapPin.numberClass()}`}
          >
            {index + 1}
          </div>
        }
      </div>
    );
  };

  return (
    <li className={`store-list-element store-list-element-minified -yodel ${store.selected ? 'store-list-highlighted' : ''}`}
      onClick={() => {
        window.ga && window.ga('send', 'event', 'new store locator', 'list click', store.id);
        onStoreSelected(store.id);
      }}
    >
      <div className="store-list-element__header">
        <div className="store-list-element__header-name">
          <div className="store-list-element__header-name-pin">
            {htmlMapPin()}
          </div>

          <h3>{store.name}</h3>
        </div>

        <div className="store-list-element__header-tag-container">
          <StoreTag store={store.store_type} isInPostStoreLocatorRebrandEnabled={isInPostStoreLocatorRebrandEnabled} />
        </div>
      </div>

      <div className="store-headline-yodel -minified">
        <div className="headline-left-side">
          <div className="store-minified-flex -padding-bottom -hidden-on-mobile">
            <img src="/assets/store-locator/yodel-map-icon.svg" alt="address-icon"
              className='store-detail-image' />
            <span itemProp="address" className="store-address">
              {store.address || ''}, {store.city || ''}, {store.county ? store.county + ',' : ''} {store.postcode || ''}
            </span>
          </div>

          {store.locker_location_type &&
            <div className="store-minified-service">
              <img src={`/assets/store-locator/${store.locker_location_type.toLowerCase()}-icon.svg`} alt="locker-type-icon"/>
              <span>            
                {store.locker_location_type}
              </span>
            </div>
          }

          {store.phone_number &&
            <div className="store-minified-flex -padding-bottom -hidden-on-mobile">
              <div className="store-service-column">
                <img src="/assets/store-locator/yodel-phone-icon.svg" alt="telephone-icon" />
                <span className="phone-number">
                  {store.phone_number}
                </span>
              </div>
            </div>
          }

          {!store.locker_location_type && store.print_in_store &&
            (
              <div className="store-minified-services -padding-bottom -hidden-on-mobile">
                <div className='store-service-column'>
                  <img src="/assets/store-locator/yodel-printer-icon.svg" alt="print-in-store-icon"
                    className='print-in-store-image'
                    title={isInPostStoreLocatorRebrandEnabled ? 'Print at shop is available here' : 'Print in store is available here'} />
                  <span className='print-in-store-text'>{isInPostStoreLocatorRebrandEnabled ? 'Print at shop' : 'Print in store'}</span>
                </div>
              </div>
            )
          }

          <div className='store-details-minified-yodel -padding-bottom'>
            {store.closed ?
              <span className='open-until open-until-minified store-closed-minified'>
                <img src="/assets/store-locator/opening_times-red_clock.svg" alt="open-hours-image"
                  className='store-detail-image' />
                <span className='store-closed-message'>{store.closing_message}</span>
              </span>
              :
              <span className='open-until open-until-minified'>
                <img src="/assets/store-locator/opening_times.svg" alt="open-hours-image"
                  className='store-detail-image' />
                {store.closing_message}
              </span>
            }
          </div>

          <div className='store-details-returns-form-container'>
            <ReturnForm
              directionUrl={direction_url}
              retailers={retailers}
              postcode={postcode}
              store={store}
              isMobileDevice={isMobileDevice}
            />
          </div>
        </div>

        <div className="headline-right-side">
          <div className="headline-distance">
            <span>{store.distance.toFixed(1)} miles</span>
          </div>
          <div className="store-minified-thumbnail -hidden-on-mobile">
            {imagesAreAllowed &&
              store.store_image_thumb_url &&
                <img src={store.store_image_thumb_url} alt="" />
            }
          </div>
        </div>
      </div>
    </li>
  );
}
